import AppHeader from "../../layout/AppHeader";
import Schedule from '../../xpost/views/register/schedule/Schedule.vue';
import ScheduleAdd from '../../xpost/views/register/schedule/ScheduleAdd.vue';

const ScheduleRoutes = [
    {
        path: "/cadastro/tarefa",
        name: "schedule",
        components: {
            header: AppHeader,
            default: Schedule
        }
    },
    {
        path: "/cadastro/tarefa/adicionar",
        name: "schedule.add",
        components: {
            header: AppHeader,
            default: ScheduleAdd
        }
    },
    {
        path: '/cadastro/tarefa/adicionar/:id',
        name: 'schedule.edit',
        components: {
            header: AppHeader,
            default: ScheduleAdd
        }
    }
]

export default ScheduleRoutes;